export function langSwitcher() {
    window.onload = () => {
        setTimeout(() => {
            const langLabel = document.querySelector(".lang-label");
            const langSelect = document.querySelector(".goog-te-combo");

            function setLang() {
                langLabel.setAttribute("data-lang", langSelect.value);
            }

            langSelect.addEventListener("change", function () {
                setLang();
            });
            langSelect.classList.add("jcf-ignore");
            setLang();
        }, 1000);
    };
}


// WEBPACK FOOTER //
// ./assets/js/modules/langSwitcher.js